<footer class="footer-menu">
  <nav class="navbar navbar-expand-md navbar-custom">
    <ul class="navbar-nav mx-auto text-center">
      <li class="nav-item">
        <a class="nav-link" href="https://ktbl.de" target="_blank"
          >KTBL-Startseite
        </a>
      </li>
      <span class="trenner">|</span>
      <li class="nav-item">
        <a class="nav-link" routerLink="/kontakt">Kontakt </a>
      </li>
      <span class="trenner">|</span>
      <li class="nav-item">
        <a
        class="nav-link"
        href="https://www.ktbl.de/service/impressum"
        target="_blank"
        >Impressum
      </a>

      </li>
      <span class="trenner">|</span>
      <li class="nav-item">
        <a
          class="nav-link"
          href="https://www.ktbl.de/service/nutzungsbedingungen-fuer-online-anwendungen"
          target="_blank"
          >Nutzungsbedingungen
        </a>
      </li>
      <span class="trenner">|</span>
      <li class="nav-item">
        <a
          class="nav-link"
          href="https://www.ktbl.de/inhalte/service/datenschutz/"
          target="_blank"
          >Datenschutzerklärung</a
        >
      </li>
    </ul>
  </nav>
</footer>
